import {
  ApplicationConfig,
  EnvironmentInjector,
  inject,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideEnvironmentInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';
import { IdlePreloadingStrategy } from './core/configs/idle-preloading.strategy';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppInjector } from './app.injector';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { duplicateSubmitInterceptor } from './core/interceptors/duplicate-submit.interceptor';
import { provideKeycloakAngular } from './core/configs/keycloak.config';
import { authErrorInterceptor } from './core/interceptors/auth.interceptor';

registerLocaleData(localePt);
//KeycloakAngularModule
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // Preload dos chunks lazy em background após o boot: sem isso, o PRIMEIRO clique em
    // cada item do menu paga o download/compilação do chunk da rota. Ocioso e um por vez
    // (IdlePreloadingStrategy): todos juntos travavam a primeira tela em PC fraco.
    provideRouter(routes, withPreloading(IdlePreloadingStrategy)),

    provideKeycloakAngular(),

    provideHttpClient(
      withInterceptors([
        // PRIMEIRO da cadeia: o segundo envio idêntico nem chega a pedir token nem a passar pelo
        // tratamento de erro — pega carona na chamada que já está em voo.
        duplicateSubmitInterceptor,
        includeBearerTokenInterceptor,
        errorInterceptor,
        authErrorInterceptor
      ])
    ),

    provideEnvironmentInitializer(() => {
      AppInjector.injector = inject(EnvironmentInjector);
    }),

    // localePt já registrado acima; sem o LOCALE_ID os pipes currency/number/date formatavam em
    // en-US (vírgula/ponto trocados). Agora R$ 1.234,56 e dd/MM/yyyy saem no padrão pt-BR.
    { provide: LOCALE_ID, useValue: 'pt-BR' },
  ],
};
